<template>
    <div class="quote">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="quote__options-group">
                        <div class="title">
                            {{ $t("promo.Choose your solar panel") }}
                        </div>
                        <div
                            class="options d-flex flex-wrap flex-md-nowrap justify-content-between"
                        >
                            <div class="option-item">
                                <input
                                    type="radio"
                                    id="glass-foil"
                                    name="solar-panel"
                                    value="glass-foil"
                                    v-model="options.panel_type"
                                />
                                <label for="glass-foil" class="panels">
                                    <strong class="mb-1">
                                        {{ $t("promo.Solarwatt Glass-Foil") }}

                                        <div style="width: 14px">
                                            <info-tooltip
                                                :text="
                                                    $t(
                                                        'promo.Tooltips - step 2 - glass-foil'
                                                    )
                                                "
                                            />
                                        </div>
                                    </strong>
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <p
                                                v-html="
                                                    $t(
                                                        'promo.370Wp per panel 15/25 years warranty'
                                                    )
                                                "
                                            ></p>
                                            <div class="radio-ui"></div>
                                            <div
                                                class="price"
                                                v-if="
                                                    options.panel_type ===
                                                    'glass-foil'
                                                "
                                            >
                                                {{ $t("promo.Included") }}
                                            </div>
                                            <div class="price" v-else>
                                                -
                                                {{
                                                    Math.round(
                                                        options.vision_surcharge *
                                                            100
                                                    ) / 100
                                                }}
                                                {{ currency }}
                                            </div>
                                        </div>
                                        <img
                                            class="panel"
                                            srcset="/images/promo/gf@2x.png 2x"
                                            src="/images/promo/gf.png"
                                            width="84"
                                            height="144"
                                        />
                                    </div>
                                </label>
                            </div>
                            <div class="option-item">
                                <input
                                    type="radio"
                                    id="glass-glass"
                                    name="solar-panel"
                                    value="glass-glass"
                                    v-model="options.panel_type"
                                />
                                <label for="glass-glass" class="panels">
                                    <strong class="mb-1">
                                        {{ $t("promo.Solarwatt Glass-Glass") }}

                                        <div style="width: 14px">
                                            <info-tooltip
                                                :text="
                                                    $t(
                                                        'promo.Tooltips - step 2 - glass-glass'
                                                    )
                                                "
                                            />
                                        </div>
                                    </strong>
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <p
                                                v-html="
                                                    $t(
                                                        'promo.320Wp per panel 30/30 years warranty'
                                                    )
                                                "
                                            ></p>
                                            <div class="radio-ui"></div>
                                            <div
                                                class="price"
                                                v-if="
                                                    options.panel_type ===
                                                    'glass-foil'
                                                "
                                            >
                                                +
                                                {{
                                                    options.vision_surcharge
                                                        | formatMoney
                                                }}
                                            </div>
                                            <div class="price" v-else>
                                                {{ $t("promo.Included") }}
                                            </div>
                                        </div>
                                        <img
                                            class="panel"
                                            srcset="/images/promo/gg@2x.png 2x"
                                            src="/images/promo/gg.png"
                                            width="84"
                                            height="144"
                                        />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="quote__options-group" v-if="locale !== 'nl'">
                        <div class="title">
                            {{ $t("promo.Financing options") }}
                        </div>
                        <div
                            class="options flex-wrap flex-lg-nowrap d-flex justify-content-between"
                        >
                            <div class="option-item">
                                <input
                                    type="radio"
                                    id="pricing-cash"
                                    name="pricing-option"
                                    value="cash"
                                    v-model="options.financing"
                                />
                                <label for="pricing-cash">
                                    <strong>
                                        {{ $t("promo.Cash") }} ({{
                                            (price * 0.9) | formatMoney
                                        }}
                                        )
                                    </strong>
                                    <div class="radio-ui"></div>
                                </label>
                            </div>
                            <div class="option-item">
                                <input
                                    type="radio"
                                    id="pricing-monthly"
                                    name="pricing-option"
                                    value="monthly"
                                    v-model="options.financing"
                                />
                                <label for="pricing-monthly">
                                    <strong>
                                        {{ (price / 72) | formatMoney }} /{{
                                            $t("promo.month 72 months")
                                        }}
                                    </strong>
                                    <div class="radio-ui"></div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="quote__options-group">
                        <div class="title">
                            {{
                                $t("promo.Customise your installation further")
                            }}
                        </div>
                        <div class="option-with-toggle" v-if="locale !== 'pl'">
                            <div class="name">
                                {{ $t("promo.Full Black Design Panels") }}

                                <div style="width: 14px">
                                    <info-tooltip
                                        :text="
                                            $t(
                                                'promo.Tooltips - step 2 - all-black'
                                            )
                                        "
                                    />
                                </div>
                            </div>
                            <div class="price-toggle">
                                +
                                {{ options.full_black_surcharge | formatMoney }}
                                <input
                                    type="checkbox"
                                    v-model="options.full_black"
                                    id="toggle-2"
                                />
                                <label for="toggle-2">
                                    <div class="ui-toggle">
                                        <span></span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <!-- /item -->
                        <div class="option-with-toggle" v-if="locale === 'pl'">
                            <div class="name">
                                {{
                                    $t("promo.Power Optimizers for each panel")
                                }}

                                <div style="width: 14px">
                                    <info-tooltip
                                        :text="
                                            $t(
                                                'promo.Tooltips - step 3 - optimizers'
                                            )
                                        "
                                    />
                                </div>
                            </div>
                            <div class="price-toggle">
                                +
                                {{ options.optimizers_surcharge | formatMoney }}
                                <input
                                    type="checkbox"
                                    v-model="options.power_optimizers"
                                    id="toggle-1"
                                />
                                <label for="toggle-1">
                                    <div class="ui-toggle">
                                        <span></span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <!-- /item -->
                        <div class="option-with-toggle" v-else>
                            <div class="name">
                                {{ $t("promo.Use microinverters") }}

                                <div style="width: 14px">
                                    <info-tooltip
                                        :text="
                                            $t(
                                                'promo.Tooltips - step 3 - microinverters'
                                            )
                                        "
                                    />
                                </div>
                            </div>
                            <div class="price-toggle">
                                +
                                {{
                                    options.microinverters_surcharge
                                        | formatMoney
                                }}
                                <input
                                    type="checkbox"
                                    v-model="options.microinverters"
                                    id="toggle-3"
                                />
                                <label for="toggle-3">
                                    <div class="ui-toggle">
                                        <span></span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <!-- /item -->
                    </div>
                    <div class="quote__disclaimer mt-4 d-block d-lg-none">
                        {{ $t("promo.Quote disclaimer") }}
                    </div>
                </div>
                <div class="col-12 col-lg-6"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import InfoTooltip from "./InfoTooltip";

export default {
    components: { InfoTooltip },
    data() {
        return {
            options: {
                panel_type: "glass-foil",
                financing: "cash",
                power_optimizers: false,
                full_black: false,
                microinverters: false,
                panels_number: 0,
                vision_surcharge: 0,
                full_black_surcharge: 0,
                optimizers_surcharge: 0,
                microinverters_surcharge: 0,
            },
        };
    },
    computed: {
        currency() {
            return process.env.MIX_APP_CURRENCY || "zł";
        },
        locale() {
            return process.env.MIX_APP_LOCALE || "pl";
        },
        ...mapGetters({
            price: "price",
            base_price: "base_price",
            stored_options: "options",
        }),
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.$store.dispatch("setOptions", this.options);
                this.updateSelectionToParent();
            },
        },
    },
    methods: {
        updateSelectionToParent() {
            var data = {
                panel_type: this.options.panel_type,
                financing: this.options.financing,
                full_black: this.options.full_black,
                power_optimizers: this.options.power_optimizers,
                microinverters: this.options.microinverters,
            };
            this.$emit("update", data);
        },
    },
    mounted() {
        if (this.stored_options) {
            this.options = this.stored_options;
        }
    },
};
</script>

<style lang="scss" scoped>
.quote {
    &__disclaimer {
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        color: rgba(20, 20, 48, 0.7);
        margin-top: 32px;
    }

    &__options {
        &-group {
            margin-top: 40px;

            .title {
                font-style: normal;
                font-weight: 600;
                font-size: 22px;
                color: #141430;
                margin-bottom: 12px;
            }

            .option-with-toggle {
                display: flex;
                justify-content: space-between;
                padding: 10px 0px;
                align-items: center;

                .name {
                    font-style: normal;
                    font-weight: normal;
                    font-size: 15px;
                    color: #1b2f51;
                }

                .price-toggle {
                    display: flex;
                    align-items: center;
                    min-width: 130px;
                    justify-content: flex-end;

                    input {
                        display: none;
                    }

                    label {
                        margin: 0;
                        margin-left: 8px;
                    }
                }

                .ui-toggle {
                    background: #d8d8d8;
                    border-radius: 120px;
                    width: 40px;
                    height: 24px;
                    position: relative;
                    transition: 0.3s;

                    span {
                        background: #ffffff;
                        height: 18px;
                        width: 18px;
                        border-radius: 50%;
                        display: block;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 3px;
                        transition: 0.3s;
                    }
                }

                :checked + label .ui-toggle {
                    background: #2775f9;
                    transition: 0.3s;

                    span {
                        left: calc(100% - 21px);
                        transition: 0.3s;
                    }
                }
            }

            .options {
                .option-item {
                    width: calc(50% - 10px);
                    @media (max-width: 768px) {
                        width: 100%;
                    }

                    .panel {
                    }

                    input {
                        display: none;
                    }

                    label {
                        padding: 18px;
                        background: #ffffff;
                        border: 1px solid #d8d8d8;
                        border-radius: 6px;
                        font-style: normal;
                        font-weight: normal;
                        font-size: 15px;
                        color: #1b2f51;
                        display: block;
                        position: relative;
                        padding-right: 36px;

                        &.panels {
                            padding: 12px 12px 4px 12px !important;
                        }

                        .radio-ui {
                            border: 1px solid #dadce6;
                            width: 18px;
                            height: 18px;
                            border-radius: 50%;
                            display: inline-block;
                            transition: 0.3s;
                        }
                    }

                    :checked + label {
                        border: 1px solid #2876f9;
                        box-shadow: 0px 0px 0px 1px #2876f9;
                        transition: 0.3s;

                        .radio-ui {
                            border-color: #2775f9;
                            box-shadow: inset 0px 0px 0px 3px #2876f9;
                            transition: 0.3s;
                        }
                    }

                    strong {
                        font-weight: normal;
                    }

                    .price {
                        font-size: 15px;
                        color: #1b2f51;
                        //border-top: 1px solid #cfd6ea;
                        display: inline-block;
                        margin-top: 12px;
                        margin-right: -22px;
                    }

                    p {
                        font-size: 15px;
                        color: #959bb5;
                        margin: 0;
                    }
                }
            }
        }
    }
}
</style>
